import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthentication } from "@/shared/hooks/useAuthentication";

export function useLogout() {
  const { deauthenticate } = useAuthentication();
  const queryClient = useQueryClient();

  const mutation = useMutation<void, Error, void>({
    mutationFn: async () => deauthenticate(),
    onSuccess: () => {
      queryClient.clear();
      window.location.href = "/";
    },
  });

  return {
    logout: () => mutation.mutate(),
    isLoggingOut: mutation.isPending || mutation.isSuccess,
  };
}
